import React from "react";
import "./AuthRebrand.css";

const AuthRebrandFrame = ({ children }) => {
  return (
    <div className="sl-auth-page">
      <main className="sl-auth-main">
        <section className="sl-auth-shell">
          <div className="sl-auth-card">{children}</div>

          <aside className="sl-auth-platform-panel" aria-label="SmartLend platform preview">
            <div className="sl-auth-ad-panel">
              <span className="sl-auth-ad-badge">SmartLend platform</span>

              <div className="sl-auth-ad-copy">
                <h2>Smarter loan access starts here.</h2>
                <p>
                  One secure account connects your profile, documents, and
                  bank-statement signals to a cleaner financing journey.
                </p>
              </div>

              <div className="sl-auth-ad-visual" aria-hidden="true">
                <div className="sl-auth-ad-orbit" />
                <div className="sl-auth-ad-card-main">
                  <div className="sl-auth-ad-card-top">
                    <span>Application health</span>
                    <strong>Ready</strong>
                  </div>
                  <h3>Prepared for lender matching.</h3>
                  <div className="sl-auth-ad-progress">
                    <span />
                  </div>
                  <div className="sl-auth-ad-card-row">
                    <div>
                      <span>Profile</span>
                      <strong>Clean</strong>
                    </div>
                    <div>
                      <span>Docs</span>
                      <strong>Added</strong>
                    </div>
                    <div>
                      <span>Signals</span>
                      <strong>Live</strong>
                    </div>
                  </div>
                </div>
              </div>

              <div className="sl-auth-ad-points" aria-hidden="true">
                <div className="sl-auth-ad-point">
                  <span>01</span>
                  <strong>Verified access</strong>
                </div>
                <div className="sl-auth-ad-point">
                  <span>02</span>
                  <strong>Cleaner review</strong>
                </div>
                <div className="sl-auth-ad-point">
                  <span>03</span>
                  <strong>Faster matching</strong>
                </div>
              </div>
            </div>
          </aside>
        </section>
      </main>
    </div>
  );
};

export default AuthRebrandFrame;
